import React from 'react';

const VideoWidget: React.FC = () => (
  <div
    style={{
      minHeight: '640px',
      width: '360px',
    }}
    id="video-bot"
  />
);

export default VideoWidget;
